import './App.css';
import Navbar from './layout/nav/Nabar'
import Routes from './routes'

function App() {
  return (
    <div>
      <Navbar/>
      <Routes/>
    </div>
  );
}

export default App;
